/* tslint:disable */
/* eslint-disable */
/**
 * Capture config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * PlatformAdminApi - axios parameter creator
 */
export const PlatformAdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback: async (code, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAuth: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/CheckAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Create a new announcement (Admin only)
         * @param {CreateAnnouncementViewModel} [createAnnouncementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncement: async (createAnnouncementViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/CreateAnnouncement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createAnnouncementViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authVersion]
         * @param {LoginViewModel} [loginViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decrypt: async (authVersion, loginViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Decrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(loginViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Delete an announcement  (Admin only)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncement: async (id, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/DeleteAnnouncement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Create a new announcement (Admin only)
         * @param {EditAnnouncementViewModel} [editAnnouncementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAnnouncement: async (editAnnouncementViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/EditAnnouncement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(editAnnouncementViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {number} [resourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActivityReport: async (resourceId, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GenerateActivityReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {Array<GetCompanyManagementViewModel>} [getCompanyManagementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompanyManagementReport: async (getCompanyManagementViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GenerateCompanyManagementReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(getCompanyManagementViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the device summary excel report
         * @param {Array<GetDeviceManagement2ViewModel>} [getDeviceManagement2ViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDeviceManagementReport: async (getDeviceManagement2ViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GenerateDeviceManagementReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(getDeviceManagement2ViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {Array<LicenseManagementViewModel>} [licenseManagementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLicenseManagementReport: async (licenseManagementViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GenerateLicenseManagementReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(licenseManagementViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Gets a list of announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GetAnnouncements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the device summary view
         * @param {string} [start]
         * @param {string} [end]
         * @param {string} [company]
         * @param {boolean} [subcompanies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceManagementDetails: async (start, end, company, subcompanies, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GetDeviceManagementDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = (start instanceof Date) ?
                    start.toISOString() :
                    start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = (end instanceof Date) ?
                    end.toISOString() :
                    end;
            }
            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }
            if (subcompanies !== undefined) {
                localVarQueryParameter['subcompanies'] = subcompanies;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Gets a list of enabled announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledAnnouncements: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GetEnabledAnnouncements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Get the grafana credentials for your own user (based on jwt)
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrafanaCredentials: async (companyView, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GetGrafanaCredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grafanaLogin: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GrafanaLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grafanaRotate: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/GrafanaRotate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authorization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspect: async (authorization, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Introspect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Capture UI login => returns rights,..
         * @param {string} [authVersion]
         * @param {LoginViewModel} [loginViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (authVersion, loginViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(loginViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout_1: async (options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push the attached device config to the specified device
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushLoggerConfig: async (id, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/PushLoggerConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push a software update to the specified device
         * @param {PlatformAdminViewModel} [platformAdminViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushUpdate: async (platformAdminViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/PushUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(platformAdminViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push a software update to the specified device by Uid
         * @param {PushUpdateDto} [pushUpdateDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushUpdateByUid: async (pushUpdateDto, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/PushUpdateByUid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(pushUpdateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Registration handler => changes pwd of a user which is not registered yet
         * @param {RegisterViewModel} [registerViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerViewModel, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/Register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(registerViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Renews the Json webtoken to expand the session time
         * @param {string} [refreshToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewToken: async (refreshToken, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/RenewToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (refreshToken != null) {
                localVarHeaderParameter['refreshToken'] = String(refreshToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Enable or disable an announcement  (Admin only)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleAnnouncement: async (id, options = {}) => {
            const localVarPath = `/v1/PlatformAdmin/ToggleAnnouncement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PlatformAdminApi - functional programming interface
 */
export const PlatformAdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlatformAdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callback(code, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callback(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.callback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAuth(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAuth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.checkAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Create a new announcement (Admin only)
         * @param {CreateAnnouncementViewModel} [createAnnouncementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnouncement(createAnnouncementViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnouncement(createAnnouncementViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.createAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authVersion]
         * @param {LoginViewModel} [loginViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decrypt(authVersion, loginViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decrypt(authVersion, loginViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.decrypt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Delete an announcement  (Admin only)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnouncement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnouncement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.deleteAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Create a new announcement (Admin only)
         * @param {EditAnnouncementViewModel} [editAnnouncementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAnnouncement(editAnnouncementViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAnnouncement(editAnnouncementViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.editAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {number} [resourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateActivityReport(resourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateActivityReport(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.generateActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {Array<GetCompanyManagementViewModel>} [getCompanyManagementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCompanyManagementReport(getCompanyManagementViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCompanyManagementReport(getCompanyManagementViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.generateCompanyManagementReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the device summary excel report
         * @param {Array<GetDeviceManagement2ViewModel>} [getDeviceManagement2ViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDeviceManagementReport(getDeviceManagement2ViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDeviceManagementReport(getDeviceManagement2ViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.generateDeviceManagementReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {Array<LicenseManagementViewModel>} [licenseManagementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLicenseManagementReport(licenseManagementViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLicenseManagementReport(licenseManagementViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.generateLicenseManagementReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Gets a list of announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnouncements(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnouncements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.getAnnouncements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the device summary view
         * @param {string} [start]
         * @param {string} [end]
         * @param {string} [company]
         * @param {boolean} [subcompanies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceManagementDetails(start, end, company, subcompanies, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceManagementDetails(start, end, company, subcompanies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.getDeviceManagementDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Gets a list of enabled announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnabledAnnouncements(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnabledAnnouncements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.getEnabledAnnouncements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Get the grafana credentials for your own user (based on jwt)
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrafanaCredentials(companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrafanaCredentials(companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.getGrafanaCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grafanaLogin(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grafanaLogin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.grafanaLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grafanaRotate(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grafanaRotate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.grafanaRotate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authorization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introspect(authorization, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introspect(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.introspect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Capture UI login => returns rights,..
         * @param {string} [authVersion]
         * @param {LoginViewModel} [loginViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(authVersion, loginViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(authVersion, loginViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout_1(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.logout_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push the attached device config to the specified device
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushLoggerConfig(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushLoggerConfig(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.pushLoggerConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push a software update to the specified device
         * @param {PlatformAdminViewModel} [platformAdminViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushUpdate(platformAdminViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushUpdate(platformAdminViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.pushUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push a software update to the specified device by Uid
         * @param {PushUpdateDto} [pushUpdateDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushUpdateByUid(pushUpdateDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushUpdateByUid(pushUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.pushUpdateByUid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Registration handler => changes pwd of a user which is not registered yet
         * @param {RegisterViewModel} [registerViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Renews the Json webtoken to expand the session time
         * @param {string} [refreshToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewToken(refreshToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewToken(refreshToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.renewToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Enable or disable an announcement  (Admin only)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleAnnouncement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleAnnouncement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformAdminApi.toggleAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PlatformAdminApi - factory interface
 */
export const PlatformAdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlatformAdminApiFp(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(code, options) {
            return localVarFp.callback(code, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAuth(options) {
            return localVarFp.checkAuth(options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Create a new announcement (Admin only)
         * @param {CreateAnnouncementViewModel} [createAnnouncementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncement(createAnnouncementViewModel, options) {
            return localVarFp.createAnnouncement(createAnnouncementViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authVersion]
         * @param {LoginViewModel} [loginViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decrypt(authVersion, loginViewModel, options) {
            return localVarFp.decrypt(authVersion, loginViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Delete an announcement  (Admin only)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncement(id, options) {
            return localVarFp.deleteAnnouncement(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Create a new announcement (Admin only)
         * @param {EditAnnouncementViewModel} [editAnnouncementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAnnouncement(editAnnouncementViewModel, options) {
            return localVarFp.editAnnouncement(editAnnouncementViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {number} [resourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActivityReport(resourceId, options) {
            return localVarFp.generateActivityReport(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {Array<GetCompanyManagementViewModel>} [getCompanyManagementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompanyManagementReport(getCompanyManagementViewModel, options) {
            return localVarFp.generateCompanyManagementReport(getCompanyManagementViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the device summary excel report
         * @param {Array<GetDeviceManagement2ViewModel>} [getDeviceManagement2ViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDeviceManagementReport(getDeviceManagement2ViewModel, options) {
            return localVarFp.generateDeviceManagementReport(getDeviceManagement2ViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the company summary excel report
         * @param {Array<LicenseManagementViewModel>} [licenseManagementViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLicenseManagementReport(licenseManagementViewModel, options) {
            return localVarFp.generateLicenseManagementReport(licenseManagementViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Gets a list of announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements(options) {
            return localVarFp.getAnnouncements(options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the device summary view
         * @param {string} [start]
         * @param {string} [end]
         * @param {string} [company]
         * @param {boolean} [subcompanies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceManagementDetails(start, end, company, subcompanies, options) {
            return localVarFp.getDeviceManagementDetails(start, end, company, subcompanies, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Gets a list of enabled announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledAnnouncements(options) {
            return localVarFp.getEnabledAnnouncements(options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Get the grafana credentials for your own user (based on jwt)
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrafanaCredentials(companyView, options) {
            return localVarFp.getGrafanaCredentials(companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grafanaLogin(options) {
            return localVarFp.grafanaLogin(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grafanaRotate(options) {
            return localVarFp.grafanaRotate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspect(authorization, options) {
            return localVarFp.introspect(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Capture UI login => returns rights,..
         * @param {string} [authVersion]
         * @param {LoginViewModel} [loginViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(authVersion, loginViewModel, options) {
            return localVarFp.login(authVersion, loginViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout_1(options) {
            return localVarFp.logout_1(options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push the attached device config to the specified device
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushLoggerConfig(id, options) {
            return localVarFp.pushLoggerConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push a software update to the specified device
         * @param {PlatformAdminViewModel} [platformAdminViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushUpdate(platformAdminViewModel, options) {
            return localVarFp.pushUpdate(platformAdminViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Push a software update to the specified device by Uid
         * @param {PushUpdateDto} [pushUpdateDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushUpdateByUid(pushUpdateDto, options) {
            return localVarFp.pushUpdateByUid(pushUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Registration handler => changes pwd of a user which is not registered yet
         * @param {RegisterViewModel} [registerViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerViewModel, options) {
            return localVarFp.register(registerViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Renews the Json webtoken to expand the session time
         * @param {string} [refreshToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewToken(refreshToken, options) {
            return localVarFp.renewToken(refreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Enable or disable an announcement  (Admin only)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleAnnouncement(id, options) {
            return localVarFp.toggleAnnouncement(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlatformAdminApi - object-oriented interface
 */
export class PlatformAdminApi extends BaseAPI {
    /**
     *
     * @param {string} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callback(code, options) {
        return PlatformAdminApiFp(this.configuration).callback(code, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkAuth(options) {
        return PlatformAdminApiFp(this.configuration).checkAuth(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Create a new announcement (Admin only)
     * @param {CreateAnnouncementViewModel} [createAnnouncementViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAnnouncement(createAnnouncementViewModel, options) {
        return PlatformAdminApiFp(this.configuration).createAnnouncement(createAnnouncementViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authVersion]
     * @param {LoginViewModel} [loginViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    decrypt(authVersion, loginViewModel, options) {
        return PlatformAdminApiFp(this.configuration).decrypt(authVersion, loginViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Delete an announcement  (Admin only)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAnnouncement(id, options) {
        return PlatformAdminApiFp(this.configuration).deleteAnnouncement(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Create a new announcement (Admin only)
     * @param {EditAnnouncementViewModel} [editAnnouncementViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editAnnouncement(editAnnouncementViewModel, options) {
        return PlatformAdminApiFp(this.configuration).editAnnouncement(editAnnouncementViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the company summary excel report
     * @param {number} [resourceId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateActivityReport(resourceId, options) {
        return PlatformAdminApiFp(this.configuration).generateActivityReport(resourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the company summary excel report
     * @param {Array<GetCompanyManagementViewModel>} [getCompanyManagementViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateCompanyManagementReport(getCompanyManagementViewModel, options) {
        return PlatformAdminApiFp(this.configuration).generateCompanyManagementReport(getCompanyManagementViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the device summary excel report
     * @param {Array<GetDeviceManagement2ViewModel>} [getDeviceManagement2ViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateDeviceManagementReport(getDeviceManagement2ViewModel, options) {
        return PlatformAdminApiFp(this.configuration).generateDeviceManagementReport(getDeviceManagement2ViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the company summary excel report
     * @param {Array<LicenseManagementViewModel>} [licenseManagementViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateLicenseManagementReport(licenseManagementViewModel, options) {
        return PlatformAdminApiFp(this.configuration).generateLicenseManagementReport(licenseManagementViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Gets a list of announcements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAnnouncements(options) {
        return PlatformAdminApiFp(this.configuration).getAnnouncements(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the device summary view
     * @param {string} [start]
     * @param {string} [end]
     * @param {string} [company]
     * @param {boolean} [subcompanies]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeviceManagementDetails(start, end, company, subcompanies, options) {
        return PlatformAdminApiFp(this.configuration).getDeviceManagementDetails(start, end, company, subcompanies, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Gets a list of enabled announcements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnabledAnnouncements(options) {
        return PlatformAdminApiFp(this.configuration).getEnabledAnnouncements(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Get the grafana credentials for your own user (based on jwt)
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGrafanaCredentials(companyView, options) {
        return PlatformAdminApiFp(this.configuration).getGrafanaCredentials(companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grafanaLogin(options) {
        return PlatformAdminApiFp(this.configuration).grafanaLogin(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grafanaRotate(options) {
        return PlatformAdminApiFp(this.configuration).grafanaRotate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authorization]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    introspect(authorization, options) {
        return PlatformAdminApiFp(this.configuration).introspect(authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Capture UI login => returns rights,..
     * @param {string} [authVersion]
     * @param {LoginViewModel} [loginViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(authVersion, loginViewModel, options) {
        return PlatformAdminApiFp(this.configuration).login(authVersion, loginViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(options) {
        return PlatformAdminApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout_1(options) {
        return PlatformAdminApiFp(this.configuration).logout_1(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Push the attached device config to the specified device
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushLoggerConfig(id, options) {
        return PlatformAdminApiFp(this.configuration).pushLoggerConfig(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Push a software update to the specified device
     * @param {PlatformAdminViewModel} [platformAdminViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushUpdate(platformAdminViewModel, options) {
        return PlatformAdminApiFp(this.configuration).pushUpdate(platformAdminViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Push a software update to the specified device by Uid
     * @param {PushUpdateDto} [pushUpdateDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushUpdateByUid(pushUpdateDto, options) {
        return PlatformAdminApiFp(this.configuration).pushUpdateByUid(pushUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Registration handler => changes pwd of a user which is not registered yet
     * @param {RegisterViewModel} [registerViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(registerViewModel, options) {
        return PlatformAdminApiFp(this.configuration).register(registerViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Renews the Json webtoken to expand the session time
     * @param {string} [refreshToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    renewToken(refreshToken, options) {
        return PlatformAdminApiFp(this.configuration).renewToken(refreshToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Enable or disable an announcement  (Admin only)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleAnnouncement(id, options) {
        return PlatformAdminApiFp(this.configuration).toggleAnnouncement(id, options).then((request) => request(this.axios, this.basePath));
    }
}
